import React from 'react';
import PropTypes from 'prop-types';
import { designSystem, reactHookForm } from '@yola/ws-ui';

const { Stack, CardSelector, FieldStatus } = designSystem;
const { useController } = reactHookForm;

const CardGroupField = ({ name, rules, items, control }) => {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  return (
    <div>
      <Stack gap="spacing-2-xs">
        {items.map(({ id, title, icon, description }) => (
          <CardSelector
            key={id}
            id={id}
            iconGlyph={icon}
            title={title}
            selected={field.value === id}
            description={description}
            descriptionAppearance="medium-emphasis"
            descriptionSize="small"
            onClick={() => field.onChange(id)}
          />
        ))}
      </Stack>
      {fieldState.invalid && <FieldStatus text={fieldState.error.message} appearance="error" />}
    </div>
  );
};

CardGroupField.propTypes = {
  name: PropTypes.string.isRequired,
  rules: PropTypes.shape().isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
  control: PropTypes.shape().isRequired,
};

export default CardGroupField;
